import "./VentilatorAlarmTableDesktopView.scss";
import filter from "../../../common/images/filter.png";
import { ALARM_TYPE_FILTER, ALARM_PRIORITY_FILTER } from "../../../common/constant/common-constants";
import lung_svg from "../../../common/icons/svg/lungs.svg";
import consolidation_svg from "../../../common/icons/svg/consolidation.svg"
import { convertUTCtoIST } from "../../../common/utils/CommonUtils";

export default function VentilatorAlarmTableDesktopView({
    tableRef,
    header,
    sortedEvents,
    selectedTypeFilter,
    selectedPriorityFilter,
    toggleFilterDropdown,
    filterDropdown,
    dropdownRef,
    handleFilterSelect,
    getPriority,
    isLoading,
}) {
    return (
        <>
            <div className="alarm-history-text">Event History</div>
            <div className="alarm-history-data-container">
                <div ref={tableRef} className="alarm-table-container">
                    <table className="alarm-table">
                        <thead className="sticky">
                            <tr>
                                {header?.map((data, count) => {
                                    const canShowPriorityFilter =
                                        selectedTypeFilter === "PHYSIOLOGICAL" ||
                                        selectedTypeFilter === "TECHNICAL";

                                    const isPriorityColumn = data === "PRIORITY";
                                    const isTypeColumn = data === "TYPE";

                                    const shouldShowFilter =
                                        isTypeColumn ||
                                        (isPriorityColumn && canShowPriorityFilter);

                                    return (
                                        <th
                                            key={count}
                                            className="alarm-header"
                                            style={{ position: "relative" }}
                                        >
                                            <div
                                                className="header-content"
                                                style={{
                                                    cursor: shouldShowFilter
                                                        ? "pointer"
                                                        : "default",
                                                }}
                                                onClick={
                                                    shouldShowFilter
                                                        ? () =>
                                                            toggleFilterDropdown(data)
                                                        : undefined
                                                }
                                            >
                                                {data}
                                                {shouldShowFilter && (
                                                    <span className="filter-icon">
                                                        <img
                                                            src={filter}
                                                            alt="filter"
                                                            width="21vw"
                                                        />
                                                    </span>
                                                )}
                                            </div>

                                            {filterDropdown.open &&
                                                filterDropdown.column === data &&
                                                shouldShowFilter && (
                                                    <div
                                                        ref={dropdownRef}
                                                        className="filter-dropdown"
                                                        style={{
                                                            position: "absolute",
                                                            top: "100%",
                                                            left: 0,
                                                            zIndex: 10,
                                                            minWidth: "9.8vw",
                                                            marginTop: "0.5vh",
                                                            zIndex: 1000,
                                                        }}
                                                    >
                                                        {(data === "TYPE"
                                                            ? ALARM_TYPE_FILTER
                                                            : ALARM_PRIORITY_FILTER
                                                        ).map((f) => (
                                                            <div
                                                                key={f.id}
                                                                onClick={() =>
                                                                    handleFilterSelect(
                                                                        f,
                                                                        data
                                                                    )
                                                                }
                                                                style={{
                                                                    padding:
                                                                        "0.7vw 2vh",
                                                                    cursor: "pointer",
                                                                    fontSize: "0.8vw",
                                                                    lineHeight:
                                                                        "20px",
                                                                    border:
                                                                        "0.6vw solid #333333",
                                                                    background:
                                                                        data === "TYPE"
                                                                            ? f.name ===
                                                                                selectedTypeFilter
                                                                                ? "#6D1DF0"
                                                                                : "#333333"
                                                                            : f.name ===
                                                                                selectedPriorityFilter
                                                                                ? "#6D1DF0"
                                                                                : "#333333",
                                                                }}
                                                            >
                                                                {f.label}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                        </th>
                                    );
                                })}
                            </tr>
                        </thead>

                        <tbody>
                            {sortedEvents?.map((row, count) => {
                                if (!row) return null;

                                const activeIST = convertUTCtoIST(
                                    row?.observedTime || ""
                                );
                                const resolveIST = convertUTCtoIST(
                                    row?.resolvedTime || ""
                                );

                                const priorityData = row?.priority
                                    ? getPriority(row.priority)
                                    : { color: "", textColor: "", icon: "" };

                                const color =
                                    row?.status === "active"
                                        ? priorityData.color
                                        : "";

                                const textColor =
                                    row?.status === "active"
                                        ? priorityData.textColor
                                        : "";

                                let type = "";
                                if (row?.type) {
                                    type = row.type
                                        .split(" ")
                                        .map((t) =>
                                            t
                                                ? t[0].toUpperCase() +
                                                t.substring(1).toLowerCase()
                                                : ""
                                        )
                                        .join(" ");
                                }

                                const displayMessage = row?.message || "";

                                return (
                                    <tr key={count}>
                                        <td
                                            style={{
                                                backgroundColor: color,
                                                color: textColor,
                                                fontSize: "0.83vw",
                                            }}
                                        >
                                            {type || "-"}
                                        </td>

                                        <td style={{ backgroundColor: color }}>
                                            <div className="alarm-priority">
                                                {(row?.type ===
                                                    "PHYSIOLOGICAL" ||
                                                    row?.type === "TECHNICAL") &&
                                                    priorityData?.icon && (
                                                        <img
                                                            alt="priority"
                                                            src={
                                                                priorityData.icon
                                                            }
                                                            className="priority"
                                                        />
                                                    )}

                                                {row?.type ===
                                                    "OPERATIONAL" && (
                                                        <img
                                                            alt="priority"
                                                            src={
                                                                row?.category ===
                                                                    "additional_feature"
                                                                    ? lung_svg
                                                                    : consolidation_svg
                                                            }
                                                            className="priority"
                                                        />
                                                    )}
                                            </div>
                                        </td>

                                        <td
                                            style={{
                                                backgroundColor: color,
                                                color: textColor,
                                            }}
                                        >
                                            {displayMessage || "-"}
                                        </td>

                                        <td
                                            style={{
                                                backgroundColor: color,
                                                color: textColor,
                                            }}
                                        >
                                            <div>{activeIST.time}</div>
                                            <div>{activeIST.date}</div>
                                        </td>

                                        <td
                                            style={{
                                                backgroundColor: color,
                                                color: textColor,
                                            }}
                                        >
                                            <div>{resolveIST.time}</div>
                                            <div>{resolveIST.date}</div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    {isLoading && (
                        <div className="spinner-container">
                            <div className="spinner"></div>
                        </div>
                    )}
                </div>

            </div>
        </>


    );
}
